module.exports = __webpack_public_path__ + "files/a6256b93238649359f9dd08277509b90.png";


//////////////////
// WEBPACK FOOTER
// ./images/favicon/android-chrome-192x192.png
// module id = 522
// module chunks = 60